import type { ReactNode } from "react"
import { Box, useMediaQuery } from "@mui/material"

/** Mesmo critério da revisão dos itens: deitado e largo o bastante para a lateral não espremer o conteúdo. */
const TELA_DEITADA = '(orientation: landscape) and (min-width: 820px)'

/** Lida já na primeira pintura: sem o noSsr o totem deitado abria um quadro com o layout de em pé. */
export function useTelaDeitada(): boolean {
    return useMediaQuery(TELA_DEITADA, { noSsr: true })
}

interface LayoutPassosProps {
    deitado: boolean
    stepper: ReactNode
    children: ReactNode
}

/**
 * Corpo das telas em passos dos totens: o pagamento do checkout e o "Finalizar pedido" do totem de pedidos.
 * Em pé: stepper, conteúdo e um box vazio. As pontas dividem a sobra igual (1fr), e o conteúdo fica no meio.
 * Deitado: o stepper vai para a lateral.
 */
export default function LayoutPassos({ deitado, stepper, children }: LayoutPassosProps): JSX.Element {
    return (
        <Box
            data-corpo-do-pagamento
            sx={deitado
                ? { flex: 1, minHeight: 0, display: 'flex' }
                : { flex: 1, minHeight: 0, overflowY: 'auto', display: 'grid', gridTemplateRows: '1fr auto 1fr', backgroundColor: (theme) => theme.palette.personal.background }
            }
        >
            <Box
                sx={deitado
                    ? { width: 280, flexShrink: 0, px: 3, py: 4, borderRight: 1, borderColor: 'divider', overflowY: 'auto', }
                    : { alignSelf: 'start', px: 3, py: 5, backgroundColor: (theme) => theme.palette.personal.background }
                }
            >
                {stepper}
            </Box>

            <Box
                data-area-do-passo
                sx={{
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: (theme) => theme.palette.personal.background,
                    ...(deitado ? { flex: 1, minHeight: 0, overflowY: 'auto' } : {}),
                }}
            >
                {children}
            </Box>

            {!deitado && <Box aria-hidden data-box-vazio />}
        </Box>
    )
}
